import { StickyNote } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

// Icona accanto al collaboratore: al passaggio del mouse mostra le sue Note.
export default function NotePreview({ note, testId, className = "mt-1.5" }) {
  const text = (note || "").trim();
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} data-testid={testId} aria-label="Note collaboratore"
            className={`${className} shrink-0 h-9 w-9 flex items-center justify-center rounded-md border border-amber-500/40 text-amber-500 hover:bg-amber-500/10 cursor-help`}>
            <StickyNote className="h-4 w-4" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" align="end" className="max-w-sm bg-popover text-popover-foreground border border-border shadow-xl" data-testid={`${testId}-content`}>
          <div className="text-[10px] uppercase tracking-wider font-mono text-amber-500 mb-1">Note</div>
          <div className="text-xs whitespace-pre-wrap leading-relaxed">{text}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
